"use strict";

// observer.js
(() => {
  window.addEventListener("load", () => {
    // 汎用アニメーション
    const selectors = [
      ".u-animation--fadeIn",
      ".u-animation--appear",
      ".u-animation--underAppear",
      ".u-animation--sectionRight",
      ".u-animation--scale",
      ".u-animation--line",
      ".u-animation--ttlReveal",
      ".p-accordion__item",
    ];

    const targets = document.querySelectorAll(selectors.join(", "));
    if (targets.length) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("js-show");
            obs.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.2, // 20%表示で発火
        }
      );

      targets.forEach((el) => observer.observe(el));
    }

    // 下から出現アニメーション
    // const underTextTargets = document.querySelectorAll(".u-animation--underAppear");
    // if (underTextTargets.length) {
    //   const underTextObserver = new IntersectionObserver(
    //     (entries, obs) => {
    //       entries.forEach((entry) => {
    //         if (!entry.isIntersecting) return;
    //         entry.target.classList.add("js-show");
    //         obs.unobserve(entry.target);
    //       });
    //     },
    //     {
    //       root: null,
    //       rootMargin: "0px 0px -30% 0px", // ScrollTrigger の start: "top 70%" 相当
    //       threshold: 0,
    //     }
    //   );

    //   underTextTargets.forEach((el) => underTextObserver.observe(el));
    // }

    // カウントアップ
    const countTargets = document.querySelectorAll(".js-count-up");
    if (countTargets.length) {
      const animateCounter = (el) => {
        const targetAttr =
          el.dataset.countTarget ?? el.dataset.target ?? el.getAttribute("data-target");
        const target = Number(targetAttr);
        if (Number.isNaN(target)) return; // 念のためガード

        const duration = Number(el.dataset.duration ?? 2000);
        const start = performance.now();

        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
          const value = target * eased;
          el.textContent = Number.isInteger(target)
            ? Math.round(value).toLocaleString()
            : value.toFixed(1);

          if (progress < 1) requestAnimationFrame(tick);
        };

        requestAnimationFrame(tick);
      };

      const countObserver = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            animateCounter(entry.target);
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.3 }
      );

      countTargets.forEach((el) => countObserver.observe(el));
    }
  });
})();
